import { render } from "./SetProduct.vue?vue&type=template&id=573fb181&scoped=true"
import script from "./SetProduct.vue?vue&type=script&lang=js"
export * from "./SetProduct.vue?vue&type=script&lang=js"

import "./SetProduct.vue?vue&type=style&index=0&id=573fb181&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573fb181"]])

export default __exports__